// Source: app/scripts/config.js
Auction.constant('settings', {
  contextPath: _contextPath,
  dateFormats: ['DD-MM', 'DD-MM-YY', 'DD-MM-YYYY', 'DD-MM-YYYY HH:mm'],
  dateParseFormats: [
    'DD.MM.YYYY HH:mm',
    'DD.MM.YYYY',
    'DD-MM-YYYY HH:mm',
    'DD-MM-YYYY',
    'DD-MM-YY',
    'DD-MM',
    'YYYY-MM-DD HH:mm',
    'YYYY-MM-DD'
  ],
  dateFormat: 'DD.MM.YYYY',
  dateFieldFormat: 'dd.MM.yyyy',
  dateFieldTimeFormat: 'HH:mm',
  dateTimeFormat: 'DD.MM.YYYY HH:mm',
  dateMinYear: 1900,
  dateMaxYear: 2100,
  useAuthTokenHeader: true,
  language: 'sq',
  translationPrefix: 'eauction.',
  version: 167
});

Auction.value('version', '0.1');

// register the interceptor as a service

Auction.factory('HRHttpInterceptors', function($q, $location, $rootScope,
                                               $filter, toaster, settings) {
  return {
    'request': function(config) {
      // Prepend context path to each request to absolute path
      if(config.url.length > 0) {
        if(config.url.charAt(0) == "/") {
          config.url = settings.contextPath + config.url;
          //use this for IE 8 compatibility
          var timestamp = function() {
              return new Date().getTime();
            };
          if(config.url.indexOf("?") == -1) {
            config.url = config.url + "?_tsmp=" + timestamp();
          } else {
            config.url = config.url + "&_tsmp=" + timestamp();
          }
        }
      }
      // Add token in each request header
      var authToken = $rootScope.authToken;
      if(angular.isDefined(authToken)) {
        if(settings.useAuthTokenHeader) {
          config.headers['X-Auth-Token'] = authToken;
        } else {
          config.url = config.url + "?token=" + authToken;
        }
      }
      return config || $q.when(config);
    },
    'responseError': function(rejection) {
      var status = rejection.status;
      var data = rejection.data;

      if(status == 400) {
        // invalid data
        $rootScope.errors = rejection.data;
        if(rejection.data._error) {
          if($rootScope.errors._error) {
            var msg = $filter('translate')($rootScope.errors._error);
            if ($rootScope.errors._field) {
              msg = msg + ': ' + $filter('translate')($rootScope.errors._field);
            }
            toaster.pop('error', $filter('translate')('generic.error'), msg);
          }
        }
        angular.forEach($rootScope.errors, function(val, key) {
          if (key === '_error' || key === '_field') {
            return;
          }
          if(val && typeof val === 'string' && val.indexOf('.') >= 0) {
            $rootScope.errors[key] = 'validation.' + val.substring(0, val.indexOf('.'));
          }
        });

      }
      if(status == 403) {
        if (data && data._error === 'password_expired') {
          console.log('Лозинката истече. Пренасочување кон промена на лозинка.');
          // Можете да ја зачувате пораката во rootScope или да ја проследите преку query params
          $rootScope.passwordExpiredMessage = data.message;
          $location.path("/expired_password");
        } else if (data && data._error === 'auth.mfa_admin_setup_required') {
          $location.path("/user/profile");
        } else {
          $location.path("/access_denied");
         }
      }
      if(status == 401) {
        if(!$rootScope.returnPath) {
          $rootScope.returnPath = $location.path();
        }
        $location.path("/login");
      }
      return $q.reject(rejection);
    }
  };
});

Auction.constant('tableParams', {
  page: 1,
  count: 10,
  sorting: {
    ID: 'asc' // initial sorting
  }
});

Auction.factory('tableConfig', function($filter, tableParams, ngTableParams) {
  var tableCfg;
  return {
    'init': function(entities) {
      this.tableCfg = {
        total: entities.length, // length
        // of data
        getData: function($defer, params) {
          // sorting
          console.log("getData(): " + entities.length);
          var sortedData = params.sorting() ? $filter('orderBy')(
            entities, params.orderBy()) : entities;
          params.total(sortedData.length);
          $defer.resolve(sortedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
        }
      };
      return new ngTableParams(tableParams, tableCfg);
    }
  }
});
